import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SentryService } from '../../services/sentry.service';

@Component({
  selector: 'app-sentry-error-tester',
  templateUrl: './sentry-error-tester.component.html',
  styleUrls: ['./sentry-error-tester.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SentryErrorTesterComponent implements OnInit {
  constructor(private sentryService: SentryService) {}

  ngOnInit(): void {}

  triggerError(type: string): void {
    this.sentryService.test(type);
  }
}
